import type {Repository} from '@github-ui/current-repository'
import {blobPath} from '@github-ui/paths'
import {EyeIcon, KebabHorizontalIcon, PencilIcon, TrashIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface BlobActionsMenuProps {
  oid: string
  path: string
  repo: Repository
  isViewable?: boolean
}

export default function BlobActionsMenu({oid, path, repo, isViewable = true}: BlobActionsMenuProps) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton aria-label="More options" icon={KebabHorizontalIcon} variant="invisible" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.LinkItem
            href={blobPath({
              repo: repo.name,
              owner: repo.ownerLogin,
              filePath: path,
              commitish: oid,
            })}
            inactiveText={isViewable ? undefined : 'Action unavailable'}
          >
            <ActionList.LeadingVisual>
              <EyeIcon />
            </ActionList.LeadingVisual>
            View file
          </ActionList.LinkItem>
          <ActionList.Item inactiveText="Action unavailable">
            <ActionList.LeadingVisual>
              <PencilIcon />
            </ActionList.LeadingVisual>
            Edit file
          </ActionList.Item>
          <ActionList.Item inactiveText="Action unavailable">
            <ActionList.LeadingVisual>
              <TrashIcon />
            </ActionList.LeadingVisual>
            Delete file
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ BlobActionsMenu.displayName ||= 'BlobActionsMenu' } catch {}